import React, {FC, useEffect, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import {fetchData, getTranslatedValue, toasterrormsg} from '../../../reusable'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {Tr} from '../../../_metronic/i18n/Tr'
import {PageTitle} from '../../../_metronic/layout/core'
import Fancybox from '../Fancybox'
import {HotelDetailsHeader} from './HotelDetailsHeader'
import {useLang} from '../../../_metronic/i18n/Metronici18n'
const HotelOverview: FC = () => {
  const t = Tr()
  const lang = useLang()
  const navigate = useNavigate()
  const categoryId = sessionStorage.getItem('categoryId')
  useEffect(() => {
    if (categoryId != '1') {
      navigate('../dashboard/')
    }
  }, [categoryId])
  const location = useLocation()
  const hotelId = (location.state as any)?.hotelId || ''
  const [hotelDetails, setHotelDetails] = useState([])
  const [qqsList, setQqsList] = useState([])

  // hotel Details api call
  const hotelDetailsApiCall = async () => {
    var param: any = {
      hotelId: hotelId,
    }
    var response: any = await fetchData('public/hotelDetailsV2', param)

    if (response.status == '200') {
      setHotelDetails(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }
  // for fancy box
  const opts = {
    fullScreen: {
      autoStart: true, // Auto-start in full-screen mode
    },
    Thumbs: false,
    // Other options...
  }
  useEffect(() => {
    hotelDetailsApiCall()
  }, [hotelId])

  const qqsListApiCall = async () => {
    var response: any = await fetchData('public/qqsList', {})
    if (response.status == '200') {
      const filterData = response.data.map((item: any) => ({label: item.name, value: item.qqsId}))
      setQqsList(filterData)
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    qqsListApiCall()
  }, [])
  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('Hotel Overview')}</PageTitle>
      <ToastContainer />
      <HotelDetailsHeader />
      {hotelDetails.map((hotel: any, index: any) => {
        var selectedQqs: any = qqsList.find((option: any) => option.value === hotel['qqs']) || null
        return (
          <div className='form' key={index}>
            {/* <!--begin::Card--> */}
            <div className='card'>
              {/* <!--begin::Card header--> */}
              <div className='card-header'>
                {/* <!--begin::Card header--> */}
                <div className='card-title fs-3 fw-bold'>{t('Basic Info')}</div>
                {/* <!--end::Card header--> */}
              </div>
              {/* <!--end::Card header--> */}
              {/* <!--begin::Card body--> */}
              <div className='card-body'>
                {hotel['en_name'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Property Name (English)')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['en_name']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['ru_name'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Property Name (Russian)')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['ru_name']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['uz_name'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Property Name (Uzbek)')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['uz_name']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['propertyTypeDetail'] && hotel['propertyTypeDetail'].length != 0 ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Property Type')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: getTranslatedValue(
                                  lang,
                                  hotel.propertyTypeDetail[0],
                                  '_name'
                                ),
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {hotel['hotelClass'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Property Class')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div>
                              {hotel['hotelClass']} {t('Stars')}
                            </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {hotel['subcategory'] &&
                  hotel['subcategory'].length > 0 &&
                  hotel['subcategory'].map((hotelsubcategory: any) => {
                    return (
                      <>
                        {getTranslatedValue(lang, hotelsubcategory, '_name') ? (
                          <>
                            {/* <!--begin::Row--> */}
                            <div className='row mb-8'>
                              {/* <!--begin::Col--> */}
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                  {t('Property Category')}
                                </div>
                              </div>
                              {/* <!--end::Col--> */}

                              {/* <!--begin::Col--> */}
                              <div className='col-xl-9'>
                                {/* <!--begin::Progress--> */}
                                <div className='d-flex flex-column'>
                                  <div className=' fw-semibold text-gray-600 mt-3'>
                                    <div>{getTranslatedValue(lang, hotelsubcategory, '_name')}</div>
                                  </div>
                                </div>
                                {/* <!--end::Progress--> */}
                              </div>
                              {/* <!--end::Col--> */}
                            </div>
                            {/* <!--end::Row--> */}
                          </>
                        ) : (
                          ''
                        )}
                      </>
                    )
                  })}

                {hotel['contact_person_name'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Contact Person Name')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div>{hotel['contact_person_name']} </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['email'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Email')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div>{hotel['email']} </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['mobileNumber'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Mobile Number')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div>{hotel['mobileNumber']} </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {hotel['location'] != '' ? (
                  <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                    <div className='fs-3 fw-bold mb-5 '>{t('Property Location')}</div>
                  </div>
                ) : (
                  ''
                )}

                {hotel['location'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Location')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div>{hotel['location']} </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {hotel['vendorDetails'] &&
                  hotel['vendorDetails'].length > 0 &&
                  hotel['vendorDetails'].map((vendordetail: any) => {
                    return (
                      <>
                        {vendordetail['country'] &&
                          vendordetail['country'].map((country: any) => {
                            return (
                              <>
                                {country['name'] ? (
                                  <>
                                    {/* <!--begin::Row--> */}
                                    <div className='row mb-8'>
                                      {/* <!--begin::Col--> */}
                                      <div className='col-xl-3'>
                                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Country')}</div>
                                      </div>
                                      {/* <!--end::Col--> */}

                                      {/* <!--begin::Col--> */}
                                      <div className='col-xl-9'>
                                        {/* <!--begin::Progress--> */}
                                        <div className='d-flex flex-column'>
                                          <div className=' fw-semibold text-gray-600 mt-3'>
                                            <div>{country['name']}</div>
                                          </div>
                                        </div>
                                        {/* <!--end::Progress--> */}
                                      </div>
                                      {/* <!--end::Col--> */}
                                    </div>
                                    {/* <!--end::Row--> */}
                                  </>
                                ) : (
                                  ''
                                )}
                              </>
                            )
                          })}

                        {vendordetail['addressline1'] ? (
                          <>
                            {/* <!--begin::Row--> */}
                            <div className='row mb-8'>
                              {/* <!--begin::Col--> */}
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Address Line 1')}</div>
                              </div>
                              {/* <!--end::Col--> */}

                              {/* <!--begin::Col--> */}
                              <div className='col-xl-9'>
                                {/* <!--begin::Progress--> */}
                                <div className='d-flex flex-column'>
                                  <div className=' fw-semibold text-gray-600 mt-3'>
                                    <div>{vendordetail['addressline1']}</div>
                                  </div>
                                </div>
                                {/* <!--end::Progress--> */}
                              </div>
                              {/* <!--end::Col--> */}
                            </div>
                            {/* <!--end::Row--> */}
                          </>
                        ) : (
                          ''
                        )}

                        {vendordetail['addressline2'] ? (
                          <>
                            {/* <!--begin::Row--> */}
                            <div className='row mb-8'>
                              {/* <!--begin::Col--> */}
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Address Line 2')}</div>
                              </div>
                              {/* <!--end::Col--> */}

                              {/* <!--begin::Col--> */}
                              <div className='col-xl-9'>
                                {/* <!--begin::Progress--> */}
                                <div className='d-flex flex-column'>
                                  <div className=' fw-semibold text-gray-600 mt-3'>
                                    <div>{vendordetail['addressline2']}</div>
                                  </div>
                                </div>
                                {/* <!--end::Progress--> */}
                              </div>
                              {/* <!--end::Col--> */}
                            </div>
                            {/* <!--end::Row--> */}
                          </>
                        ) : (
                          ''
                        )}
                        {vendordetail['region'] ? (
                          <>
                            {/* <!--begin::Row--> */}
                            <div className='row mb-8'>
                              {/* <!--begin::Col--> */}
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Region')}</div>
                              </div>
                              {/* <!--end::Col--> */}

                              {/* <!--begin::Col--> */}
                              <div className='col-xl-9'>
                                {/* <!--begin::Progress--> */}
                                <div className='d-flex flex-column'>
                                  <div className=' fw-semibold text-gray-600 mt-3'>
                                    <div>
                                      {getTranslatedValue(
                                        lang,
                                        vendordetail['regionDetail'][0],
                                        '_name'
                                      )}
                                    </div>
                                  </div>
                                </div>
                                {/* <!--end::Progress--> */}
                              </div>
                              {/* <!--end::Col--> */}
                            </div>
                            {/* <!--end::Row--> */}
                          </>
                        ) : (
                          ''
                        )}
                        {vendordetail['zipcode'] ? (
                          <>
                            {/* <!--begin::Row--> */}
                            <div className='row mb-8'>
                              {/* <!--begin::Col--> */}
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Zip Code')}</div>
                              </div>
                              {/* <!--end::Col--> */}

                              {/* <!--begin::Col--> */}
                              <div className='col-xl-9'>
                                {/* <!--begin::Progress--> */}
                                <div className='d-flex flex-column'>
                                  <div className=' fw-semibold text-gray-600 mt-3'>
                                    <div>{vendordetail['zipcode']}</div>
                                  </div>
                                </div>
                                {/* <!--end::Progress--> */}
                              </div>
                              {/* <!--end::Col--> */}
                            </div>
                            {/* <!--end::Row--> */}
                          </>
                        ) : (
                          ''
                        )}
                      </>
                    )
                  })}

                {hotel['en_generalInformation'] != '' ? (
                  <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                    <div className='fs-3 fw-bold mb-5 '>{t('Property Details')}</div>
                  </div>
                ) : (
                  ''
                )}

                {hotel['en_generalInformation'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>
                          {t('General Information (English)')}
                        </div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: hotel['en_generalInformation'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['ru_generalInformation'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>
                          {t('General Information (Russian)')}
                        </div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: hotel['ru_generalInformation'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['uz_generalInformation'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>
                          {t('General Information (Uzbek)')}
                        </div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: hotel['uz_generalInformation'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['amenityId'].length > 0 ? (
                  <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                    <div className='fs-3 fw-bold mb-5 '>{t('Facilities Service')}</div>
                  </div>
                ) : (
                  ''
                )}

                {hotel['amenityId'] && hotel['amenityId'].length > 0 && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Property Amenities')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className='fw-semibold text-gray-600 mt-3'>
                          {/* Render the comma-separated amenity names */}
                          {hotel['amenityId']
                            .filter((amenity: any) => getTranslatedValue(lang, amenity, '_name')) // Filter out amenities without a name
                            .map((amenity: any) => getTranslatedValue(lang, amenity, '_name')) // Extract the names
                            .join(', ')}
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {hotel['serviceLanguageDetail'] && hotel['serviceLanguageDetail'].length > 0 && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t('Service Languages')}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className='fw-semibold text-gray-600 mt-3'>
                          {/* Render the comma-separated amenity names */}
                          {hotel['serviceLanguageDetail']
                            .filter((serviceLanguage: any) =>
                              getTranslatedValue(lang, serviceLanguage, '_name')
                            ) // Filter out amenities without a name
                            .map((serviceLanguage: any) =>
                              getTranslatedValue(lang, serviceLanguage, '_name')
                            ) // Extract the names
                            .join(', ')}
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}

                {hotel['checkInTime'] != '' ? (
                  <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                    <div className='fs-3 fw-bold mb-5 '>{t('Policies')}</div>
                  </div>
                ) : (
                  ''
                )}

                {hotel['checkInTime'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Check In Time')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            {hotel['checkInTime']}
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['checkOutTime'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Check Out Time')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            {hotel['checkOutTime']}
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {hotel['en_cancellationPolicy'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>
                          {t('Cancellation Policy (English)')}
                        </div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: hotel['en_cancellationPolicy'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['ru_cancellationPolicy'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>
                          {t('Cancellation Policy (Russian)')}
                        </div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: hotel['ru_cancellationPolicy'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['uz_cancellationPolicy'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>
                          {t('Cancellation Policy (Uzbek)')}
                        </div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: hotel['uz_cancellationPolicy'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {hotel['en_userGuide'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('User Guide (English)')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['en_userGuide']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['ru_userGuide'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('User Guide (Russian)')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['ru_userGuide']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['uz_userGuide'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('User Guide (Uzbek)')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['uz_userGuide']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {hotel['customPolicy'].length > 0 ? (
                  <div className='col-xl-3 mb-5 mt-5'>
                    <div className='fs-3 fw-bold mb-5 '>{t('Custom Policy')}</div>
                  </div>
                ) : (
                  ''
                )}

                <div className='custom-docs-container'>
                  {hotel['customPolicy'] &&
                    hotel['customPolicy'].length > 0 &&
                    hotel['customPolicy'].map((item: any, index: any) => {
                      return (
                        <div key={index} className='custom-docs-item'>
                          {item['en_title'] && (
                            <div className='custom-docs-block'>
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                  {t('Custom Policy English Title')}
                                </div>
                              </div>
                              <div className='col-xl-9'>
                                <div className='d-flex flex-column'>
                                  <div className='fw-semibold text-gray-600 mt-3'>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item['en_title'],
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {item['en_description'] && (
                            <div className='custom-docs-block'>
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                  {t('Custom Policy English Description')}
                                </div>
                              </div>
                              <div className='col-xl-9'>
                                <div className='d-flex flex-column'>
                                  <div className='fw-semibold text-gray-600 mt-3'>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item['en_description'],
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {item['ru_title'] && (
                            <div className='custom-docs-block'>
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                  {t('Custom Policy Russian Title')}
                                </div>
                              </div>
                              <div className='col-xl-9'>
                                <div className='d-flex flex-column'>
                                  <div className='fw-semibold text-gray-600 mt-3'>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item['ru_title'],
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {item['ru_description'] && (
                            <div className='custom-docs-block'>
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                  {t('Custom Policy Russian Description')}
                                </div>
                              </div>
                              <div className='col-xl-9'>
                                <div className='d-flex flex-column'>
                                  <div className='fw-semibold text-gray-600 mt-3'>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item['ru_description'],
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {item['uz_title'] && (
                            <div className='custom-docs-block'>
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                  {t('Custom Policy Uzbek Title')}
                                </div>
                              </div>
                              <div className='col-xl-9'>
                                <div className='d-flex flex-column'>
                                  <div className='fw-semibold text-gray-600 mt-3'>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item['uz_title'],
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {item['uz_description'] && (
                            <div className='custom-docs-block'>
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                  {t('Custom Policy Uzbek Description')}
                                </div>
                              </div>
                              <div className='col-xl-9'>
                                <div className='d-flex flex-column'>
                                  <div className='fw-semibold text-gray-600 mt-3'>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item['uz_description'],
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )
                    })}
                </div>

                {hotel['ownerName'] != '' ? (
                  <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                    <div className='fs-3 fw-bold mb-5 '>{t('Finance & legal')}</div>
                  </div>
                ) : (
                  ''
                )}

                {/* <!--begin::Row--> */}

                {hotel['ownerName'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Property Owner Name')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['ownerName']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['passportNumber'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('ID/Passport Number')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['passportNumber']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['jShShIR'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('JShShIR (ПИНФЛ)')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['jShShIR']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {hotel['businessName'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Business Name')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['businessName']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['businessSTIR'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Business STIR')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['businessSTIR']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {hotel['qqs'] && selectedQqs ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('QQS')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: selectedQqs.label}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {hotel['mxikkodi'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('MXIK kodi')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['mxikkodi']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['oIchovBirligi'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("O'Ichov Birligi")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['oIchovBirligi']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['bankName'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Bank Name')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['bankName']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['branchName'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Branch Name')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['branchName']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['accountName'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Account Name')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['accountName']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['accountNumber'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('Account Number')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['accountNumber']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {hotel['mfo'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('MFO')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['mfo']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {hotel['stir'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t('STIR')}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: hotel['stir']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                <div className='row align-items-end h-100 gx-5 gx-xl-10'>
                  {hotel['businessDocument'] != '' ? (
                    <Fancybox options={opts}>
                      {/* <!--begin::Col--> */}
                      <div className='col-md-4 mb-11 mb-md-0' key={index}>
                        {/* <!--begin::Overlay--> */}
                        <a
                          data-fancybox='gallery'
                          className='d-block overlay'
                          data-fslightbox='lightbox-hot-sales'
                          href={hotel['businessDocument']}
                        >
                          {/* <!--begin::Image--> */}
                          <div
                            className={`overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-${
                              hotel['businessDocument'].toLowerCase().endsWith('.pdf')
                                ? 'contain'
                                : 'cover'
                            }  h-200px card-rounded mb-3`}
                            style={{
                              height: '266px',
                              backgroundImage: `url('${
                                hotel['businessDocument'].toLowerCase().endsWith('.pdf')
                                  ? toAbsoluteUrl('/media/otherSVG/pdf.svg')
                                  : hotel['businessDocument']
                              }')`,
                            }}
                          ></div>
                          {/* <!--end::Image--> */}

                          {/* <!--begin::Action--> */}
                          <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                            <i className='ki-outline ki-eye fs-3x text-white'></i>{' '}
                          </div>
                          {/* <!--end::Action-->       */}
                        </a>
                        {/* <!--end::Overlay-->          */}
                      </div>
                      {/* <!--end::Col-->      */}
                    </Fancybox>
                  ) : (
                    ''
                  )}

                  {hotel['idProofDocument'] != '' ? (
                    <Fancybox options={opts}>
                      {/* <!--begin::Col--> */}
                      <div className='col-md-4 mb-11 mb-md-0' key={index}>
                        {/* <!--begin::Overlay--> */}
                        <a
                          data-fancybox='gallery'
                          className='d-block overlay'
                          data-fslightbox='lightbox-hot-sales'
                          href={hotel['idProofDocument']}
                        >
                          {/* <!--begin::Image--> */}
                          <div
                            className={`overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-${
                              hotel['businessDocument'].toLowerCase().endsWith('.pdf')
                                ? 'contain'
                                : 'cover'
                            }  h-200px card-rounded mb-3`}
                            style={{
                              height: '266px',
                              backgroundImage: `url('${
                                hotel['idProofDocument'].toLowerCase().endsWith('.pdf')
                                  ? toAbsoluteUrl('/media/otherSVG/pdf.svg')
                                  : hotel['idProofDocument']
                              }')`,
                            }}
                          ></div>
                          {/* <!--end::Image--> */}
                          {/* <!--begin::Action--> */}
                          <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                            <i className='ki-outline ki-eye fs-3x text-white'></i>{' '}
                          </div>
                          {/* <!--end::Action-->       */}
                        </a>
                        {/* <!--end::Overlay-->          */}
                      </div>
                      {/* <!--end::Col-->      */}
                    </Fancybox>
                  ) : (
                    ''
                  )}
                </div>

                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                  <div className='fs-3 fw-bold  mb-5'>{t('Hotel Photos')}</div>
                </div>

                {hotel['images'] && hotel['images'].length != 0 ? (
                  <div className='col-xl-12'>
                    {/* <!--begin::Engage widget 7--> */}
                    <div className='card card-flush h-xl-100'>
                      <div className='pt-7'>
                        <div className='row align-items-end h-100 gx-5 gx-xl-10'>
                          {hotel['images'].map((images: any, index: any) => {
                            return (
                              <>
                                <Fancybox options={opts}>
                                  {/* <!--begin::Col--> */}
                                  <div className='col-md-4 mb-11 mb-md-0' key={index}>
                                    {/* <!--begin::Overlay--> */}
                                    <a
                                      data-fancybox='gallery'
                                      className='d-block overlay'
                                      data-fslightbox='lightbox-hot-sales'
                                      href={images['mediaPath']}
                                    >
                                      <div
                                        className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                                        style={{
                                          height: '266px',
                                          backgroundImage: `url('${images['mediaPath']}')`,
                                        }}
                                      ></div>
                                      {/* <!--end::Image--> */}

                                      {/* <!--begin::Action--> */}
                                      <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                                        <i className='ki-outline ki-eye fs-3x text-white'></i>{' '}
                                      </div>
                                      {/* <!--end::Action-->       */}
                                    </a>
                                    {/* <!--end::Overlay-->          */}
                                  </div>
                                  {/* <!--end::Col-->      */}
                                </Fancybox>
                              </>
                            )
                          })}
                        </div>
                        {/* <!--end::Row--> */}
                      </div>
                      {/* <!--end::Card body--> */}
                    </div>
                    {/* <!--end::Engage widget 7--> */}
                  </div>
                ) : (
                  <div className='col-xl-12'>
                    {/* <!--begin::Engage widget 1--> */}
                    <div className='card h-md-100' dir='ltr'>
                      {/* <!--begin::Body--> */}
                      <div className='card-body d-flex flex-column flex-center'>
                        {/* <!--begin::Heading--> */}
                        <div className='mb-2'>
                          {/* <!--begin::Illustration--> */}
                          <div className='py-10 text-center'>
                            <img
                              src={toAbsoluteUrl('/media/svg/illustrations/easy/2.svg')}
                              className='theme-light-show h-125px'
                              alt=''
                            />
                            <img
                              src={toAbsoluteUrl('/media/svg/illustrations/easy/2-dark.svg')}
                              className='theme-dark-show h-125px'
                              alt=''
                            />
                          </div>
                          {/* <!--end::Illustration--> */}
                        </div>
                        {/* <!--end::Heading--> */}
                      </div>
                      {/* <!--end::Body--> */}
                    </div>
                    {/* <!--end::Engage widget 1--> */}
                  </div>
                )}
              </div>
            </div>
            {/* <!--end::Card--> */}
          </div>
        )
      })}
    </>
  )
}

export {HotelOverview}
